export { default as errorHandler } from './error-handler';
export { default as routes } from './routes';

export function hasFeat(feature: string): boolean {
  const feats = window.env.SOCIAL.FEAT as Record<string, boolean>;
  return feats[feature] || false;
}
